import type { IconData } from '@stacksjs/iconify-core'

export const logoSoundcloud1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 16H32v6.1h-1.52Zm-1.53 6.1h1.53v1.52h-1.53Zm0-7.62h1.53V16h-1.53Zm-1.52 9.14h1.52v1.52h-1.52Zm0-10.67h1.52v1.53h-1.52ZM16.76 25.14V6.86h1.53V5.33h-3.05v21.34h12.19v-1.53zm7.62-13.71h3.05v1.52h-3.05Zm-1.52 1.52h1.52v1.53h-1.52Zm0-3.05h1.52v1.53h-1.52Z\"/><path fill=\"currentColor\" d=\"M21.34 14.48h1.52V16h-1.52Zm0-6.1h1.52V9.9h-1.52Zm-3.05-1.52h3.05v1.52h-3.05Zm-6.1 0h1.53v19.81h-1.53ZM9.15 8.38h1.52v18.29H9.15ZM6.1 12.95h1.52v13.72H6.1Zm-3.05 0h1.52v12.19H3.05ZM0 16h1.53v7.62H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default logoSoundcloud1
